export default "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAUIAAAAGAQMAAACM3QURAAAAA1BMVEX0pxDpRtycAAAAC0lEQVQI12MYwQAAAPwAAQAk8tUAAAAASUVORK5CYII="